/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getBulkRedriveWorkflowEntries =
  /* GraphQL */ `query GetBulkRedriveWorkflowEntries($requestId: String!) {
  getBulkRedriveWorkflowEntries(requestId: $requestId) {
    requestId
    redriveRequest
    externalId
    workflowType
    eventVersionOverride
    fusenExecutionMode
    createNewWorkflow
    environment
    sentToRedriveSQS
    successfullySentToRedrive
    workflowStatus
    expirationDate
    sentToWorkflowStatusSQS
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetBulkRedriveWorkflowEntriesQueryVariables,
    APITypes.GetBulkRedriveWorkflowEntriesQuery
  >;
